// JOBE-0106: EntitiesTab — full-grid <EntityBrowser> instance
// namespaced "entities" with NO default type chip (catch-all browser
// scoped to inProject).

import React from 'react';
import { EntityBrowser } from '../../entitybrowser/EntityBrowser.jsx';

export function EntitiesTab({ projectURN, roster }) {
  return (
    <div className="project-tab project-tab-entities" data-testid="project-tab-entities">
      <EntityBrowser
        anchor={{ inProject: projectURN }}
        urlStateNamespace="entities"
        roster={roster}
      />
    </div>
  );
}
